<template>
  <v-card>
    <v-form @submit.prevent="submitEditVehicleType()" ref="editVehicleTypeForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="vehicleType.name"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedVehicleType.name"
              label="* Name"
              :loading="loading"
              :rules="typeNameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model.number="editedVehicleType.tonnage"
              label="* Maximum Tonnage"
              :loading="loading"
              :rules="tonnageRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              :items="vehicleTypeClasses"
              color="indigo"
              v-model="editedVehicleType.class"
              label="Class"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleService from "@/services/requests/vehicleService";

// MIXINS
import VehicleValidation from "@/services/validation/vehicleValidation";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";

export default {
  mixins: [VehicleValidation],
  components: {
    DialogHeader
  },
  data() {
    return {
      editedVehicleType: Object.assign({}, this.vehicleType),
      loading: false,
      vehicleTypeClasses: [
        {
          text: "Truck",
          value: "TRUCK"
        },
        {
          text: "Plant",
          value: "PLANT"
        }
      ]
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedVehicleType = Object.assign({}, this.vehicleType);
      this.close();
    },
    submitEditVehicleType() {
      if (!this.$refs.editVehicleTypeForm.validate()) {
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      VehicleService.updateVehicleType(this.editedVehicleType)
        .then(result => {
          this.loading = false;
          this.$store.commit("vehicleTypes/updateArrayStateByValue", {
            prop: "vehicleTypes",
            value: this.vehicleType,
            editedValue: result.data.result.vehicleType
          });
          this.editedVehicleType = Object.assign(
            {},
            result.data.result.vehicleType
          );
          this.snack({ color: "green", text: "VehicleType was edited" });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.vehicleType, this.editedVehicleType)) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    vehicleType: Object
  },
};
</script>

<style>
</style>
